import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnChanges,
  OnDestroy,
  OnInit,
  input,
  viewChild,
} from '@angular/core';
import { DotCMSBasicContentlet } from '@dotcms/types';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { ReplaySubject, Subject } from 'rxjs';
import { A11y, Navigation, Pagination, Scrollbar, SwiperOptions } from 'swiper';
import SwiperCore, { Keyboard, Mousewheel } from 'swiper';
import { SwiperModule } from 'swiper/angular';

import {
  LARGE_BREAKPOINT_WIDTH,
  MEDIUM_BREAKPOINT_WIDTH,
  SMALL_BREAKPOINT_WIDTH,
} from 'ish-core/configurations/injection-keys';

import { DotCmsUveContentRenderComponent } from '../../components/dot-cms-uve-content-render/dot-cms-uve-content-render.component';
import { CustomDotCmsUveContentletHelper } from '../../models/contentlet/custom-dot-cms-uve-contentlet.helper';
import { GlobalCarouselContentlet } from '../../models/dot-cms-uve-contentlet.model';
import { configureSwiper, sliceContents } from '../../utils/dot-cms-uve-utils';

SwiperCore.use([Keyboard, Mousewheel]);

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

@Component({
  selector: 'custom-dot-cms-global-carousel',
  templateUrl: './dot-cms-uve-global-carousel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, SwiperModule, DotCmsUveContentRenderComponent],
})
export class DotCmsUveGlobalCarouselComponent implements OnInit, OnDestroy, OnChanges {
  readonly contentlet = input<GlobalCarouselContentlet>(undefined);
  // contentlet: CustomDotCmsContentlet;
  slideItems: number;
  posIni: number;

  readonly carousel = viewChild<NgbCarousel>('ngbCarousel');

  carouselContents: DotCMSBasicContentlet[];
  private destroy$ = new Subject<void>();
  itemGridSize = 12;
  contentTypes: string[] = ['banners', 'images', 'videos', 'productsTooltip', 'blogs', 'categoryCard'];
  identifier$ = new ReplaySubject<string>(1);
  swiperConfig: SwiperOptions;

  breakPointWidths: [number, number, number];
  constructor(
    @Inject(SMALL_BREAKPOINT_WIDTH) private smallBreakpointWidth: number,
    @Inject(MEDIUM_BREAKPOINT_WIDTH) private mediumBreakpointWidth: number,
    @Inject(LARGE_BREAKPOINT_WIDTH) private largeBreakpointWidth: number
  ) {
    this.swiperConfig = {
      direction: 'horizontal',
      navigation: true,
      observer: true,
      observeParents: true,
      mousewheel: { forceToAxis: true },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
    };
    this.breakPointWidths = [this.smallBreakpointWidth, this.mediumBreakpointWidth, this.largeBreakpointWidth];
  }

  ngOnChanges(): void {
    this.triggerChanges();
  }

  ngOnInit() {
    this.triggerChanges();
  }

  triggerChanges() {
    this.carouselContents = CustomDotCmsUveContentletHelper.getSortedSubContentlets(
      this.contentlet(),
      this.contentTypes,
      'sortOrder'
    );

    //No.of.Items Logic
    // this.carouselContents = this.rearrangeCategories(this.carouselContents);
    this.carouselContents = sliceContents(+this.contentlet().noOfItems, this.carouselContents);
    Object.entries(configureSwiper(this.contentlet(), this.breakPointWidths)).map(([key, value]) => {
      //@ts-ignore
      this.swiperConfig[key] = value;
    });

    this.swiperConfig.navigation = this.carouselContents.length > +this.contentlet().slideItems ? true : false;
    this.swiperConfig.loop = this.carouselContents.length > +this.contentlet().slideItems ? true : false;
  }

  rearrangeCategories(contentletArray: DotCMSBasicContentlet[]) {
    if (
      this.contentlet().loop &&
      +this.contentlet().slideItems !== 0 &&
      contentletArray.length > +this.contentlet().slideItems &&
      contentletArray.length % +this.contentlet().slideItems !== 0
    ) {
      let categoriesIn = contentletArray;
      const sliceval = +this.contentlet().slideItems - (contentletArray.length % +this.contentlet().slideItems);
      categoriesIn = [...categoriesIn, ...categoriesIn.slice(0, sliceval)];
      contentletArray = categoriesIn;
    }
    return contentletArray;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
